import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { NewRole } from '@/types/role';
import { Button } from '../UiElements';

type RoleFormProps = {
    onSubmit: (roleRequest: NewRole) => void;
};

const RoleForm = ({ onSubmit }: RoleFormProps) => {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm<NewRole>();

    const handleOnRoleSubmit: SubmitHandler<NewRole> = (data) => {
        const newRole: NewRole = {
            ...data
        }
        onSubmit(newRole);
    };

    return (
        <form className="w-full" onSubmit={handleSubmit(handleOnRoleSubmit)}>
            {/* Name Input */}
            {/*<h1 className='flex bold text-xl justify-center'>Add new role</h1>*/}
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
                    Name
                </label>
                <input
                    className={`transition-all outline-none
                        w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                        placeholder:text-gray-400 placeholder:text-text-md
                        focus:shadow-focus focus:border-primary-500
                        hover:border-primary-500 shadow-xs p-2
                    `}
                    placeholder="Name"
                    {...register('name', { required: 'This field is required' })}
                />
                {errors.name && <p className="text-red-500 text-xs italic">{errors.name.message}</p>}
            </div>

            {/* Description Input */}
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description">
                    Description
                </label>
                <input
                    className={`transition-all outline-none
                        w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                        placeholder:text-gray-400 placeholder:text-text-md
                        focus:shadow-focus focus:border-primary-500
                        hover:border-primary-500 shadow-xs p-2
                    `}
                    placeholder="Description"
                    {...register('description', { required: 'This field is required' })}
                />
                {errors.description && <p className="text-red-500 text-xs italic">{errors.description.message}</p>}
            </div>
            {/* Submit Button */}
            <Button
                type='alt'
                className={'flex-row flex w-full'}
            >
                <div className={'flex flex-row gap-md'}>
                Add Role
                </div>
            </Button>
        </form>
    );
};

export default RoleForm;
